'use strict';

import { State } from 'angular-store';
import { Controller } from '@/decorators/ngCtrl';

@Controller
class CookiesView {
  constructor() {
    'ngInject';
  }
}

export default CookiesView;
